import gql from 'graphql-tag';
import gqlClient from 'js/graphql/client/gqlClient';
import logoutUser from 'js/graphql/logout';

export const queryInvitedCreators = async campaignId => {
    try {
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }

        const result = await gqlClient.client.query({
            query: gql`
                query CampaignInvitedCreators($campaignId: ID!) {
                    campaignInvitedCreators(campaignId: $campaignId) {
                        creators {
                            id
                            firstName
                            lastName
                            gender
                            birthDate
                            location
                            address
                            address2
                            city
                            zip
                            country
                            relationship
                            phoneNumber
                            email
                            snEmail
                            notes
                            instagramMetadata {
                                userHandle
                            }
                            tiktokMetadata {
                                userHandle
                            }
                        }
                    }
                }
            `,
            variables: {campaignId}
        });

        return result.data.campaignInvitedCreators.creators;
    } catch (error) {
        if (error.message.includes('401')) {
            return logoutUser();
        }

        throw error;
    }
};



// WEBPACK FOOTER //
// ./graphql/queries/queryInvitedCreators.js